"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigateToLogin = exports.navigateToFrontpage = void 0;
var _pages = _interopRequireDefault(require("../constants/pages.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var navigateToLogin = exports.navigateToLogin = function navigateToLogin() {
  if (window && window.location && window.location.port === '3000') {
    window.location = "http://localhost:3001".concat(_pages["default"].appPrefix);
  } else {
    window.location = _pages["default"].appPrefix;
  }
};
var navigateToFrontpage = exports.navigateToFrontpage = function navigateToFrontpage() {
  if (window && window.location && window.location.port === '3001') {
    window.location = 'http://localhost:3000';
  } else {
    window.location = '/';
  }
};